import Common from '../service/common'
import RequestUtils from '../utils/requestUtils'
// import Permission from '../utils/permission'
import { guid } from '../utils/index'
import { Message } from 'element-ui'
import { flat, formatMenuList } from '../utils/formatMenu'
const getFirstMenu = menu => {
  let url
  for (let i = 0; i < menu.length; i++) {
    const item = menu[i]
    if (item.funcAddress) {
      return item.funcAddress
    }
    if (item.children.length) {
      for (let j = 0; j < item.children.length; j++) {
        const sitem = item.children[j]
        if (sitem.funcAddress) {
          return sitem.funcAddress
        }
      }
    }
  }
  console.log(url)
  return url
}
export default {
  namespaced: true,
  state: {
    userInfo: JSON.parse(localStorage.getItem('djktest.userInfo')) || {},
    menu: JSON.parse(localStorage.getItem('djktest.userMenu')) || [],
    // permission: JSON.parse(localStorage.getItem('djktest.permission')) || {},
    userDetail: {}
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    // setPermission(state, payload) {
    // state.permission = payload
    // },
    setUserDetail(state, payload) {
      state.userDetail = { ...state.userDetail, ...payload }
    },
    setMenu(state, payload) {
      state.menu = payload
    },
    reset(state) {
      localStorage.removeItem('djktest.userInfo')
      localStorage.removeItem('djktest.userMenu')
      // localStorage.removeItem('djktest.permission')
      state.userInfo = {}
      state.menu = []
      // state.permission = {}
      state.userDetail = {}
    }
  },
  actions: {
    uploadfile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadfile(payload), { type: 'action', success, fail })
    },
    login({ commit }, { payload, success, fail }) {
      Common.login(payload)
        .then(res => {
          const { result, message } = res.data
          if ([0].includes(result)) {
            const localData = { ...res.data, ...payload }
            // const permission = Permission.formatUserPermission(localData.orgType, localData.isAdmin, localData.operType)
            localStorage.setItem('djktest.userInfo', JSON.stringify(localData))
            // localStorage.setItem('djktest.permission', JSON.stringify(permission))
            commit('setUserInfo', localData)
            // commit('setPermission', permission)
            // dispatch('getportalmenutree', { payload: {}, success, fail })
            success && success()
          } else {
            fail && fail(result)
            Message.error(message)
          }
        })
        .catch(err => {
          fail && fail(err)
          Message.error(err.message)
        })
    },
    getMenuList({ commit }, { success }) {
      const errorTitle = '加载菜单失败，请刷新！'
      Common.getportalmenutree({ })
        .then(res => {
          const { result, menuNodes } = res.data
          if ([0].includes(result)) {
            const menuList = formatMenuList(menuNodes)
            console.log(menuList)
            const menu = flat(menuList, 'funcAddress')
            commit('setMenu', menuList)
            success && success(menu[0], menu)
          } else {
            Message.error(errorTitle)
          }
        })
        .catch(err => {
          console.log(err)
          Message.error(errorTitle)
        })
    },
    logout({ commit }, { success }) {
      RequestUtils.fetchWrapper(Common.logout(), {
        type: 'info',
        success: () => {
          success && success()
          setTimeout(() => {
            commit('reset')
          }, 20)
        },
        fail: () => {}
      })
    },
    getportalmenutree({ commit }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getportalmenutree(payload), {
        type: 'info',
        success: (res) => {
          const menu = []
          function formatMenu(menus) {
            const menuList = []
            menus.forEach(i => {
              i.activePath = i.funcAddress || guid()
              const children = i.children || []
              children.forEach(s => {
                s.activePath = s.funcAddress || guid()
              })
              menuList.push(i)
            })
            return menuList
          }
          res.data.menuNodes.forEach((i) => {
            const children = i.children
            const firstUrl = getFirstMenu(children)
            menu.push({ ...i, activePath: i.menuId, funcAddress: firstUrl, children: formatMenu(children) })
          })
          localStorage.setItem('djktest.userMenu', JSON.stringify(menu))
          commit('setMenu', menu)
          success && success(menu[0].funcAddress)
        },
        fail: () => {
          commit('reset')
          fail && fail(9999)
        }
      })
    },

    getservices(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getservices(payload), { type: 'list', success, fail })
    },
    getservicecategorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getservicecategorys(payload), { type: 'list', success, fail })
    },
    addservicecategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addservicecategory(payload), { type: 'action', success, fail })
    },
    updateservicecategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updateservicecategory(payload), { type: 'action', success, fail })
    },
    deleteservicecategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deleteservicecategory(payload), { type: 'action', success, fail })
    },

    getnamecards(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getnamecards(payload), { type: 'list', success, fail })
    },
    addnamecard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addnamecard(payload), { type: 'action', success, fail })
    },
    updatenamecard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updatenamecard(payload), { type: 'action', success, fail })
    },
    deletenamecard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deletenamecard(payload), { type: 'action', success, fail })
    },
    downloadnamecardtemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.downloadnamecardtemplate(payload), { type: 'file', success, fail })
    },
    uploadnamecard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadnamecard(payload), { type: 'action', success, fail })
    },
    getvendoruploadtemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendoruploadtemplate(payload), { type: 'file', success, fail })
    },
    uploadvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadvendor(payload), { type: 'action', success, fail })
    },
    getbasicdatastat(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getbasicdatastat(payload), { type: 'info', success, fail })
    },
    gettrainingstat(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.gettrainingstat(payload), { type: 'info', success, fail })
    },
    getinspeciontstat(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getinspeciontstat(payload), { type: 'info', success, fail })
    },

    getcitytree(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getcitytree(payload), { type: 'list', success, fail })
    },
    getareatree(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getareatree(payload), { type: 'list', success, fail })
    },
    getstaffs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getstaffs(payload), { type: 'list', success, fail })
    },
    addstaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addstaff(payload), { type: 'action', success, fail })
    },
    updatestaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updatestaff(payload), { type: 'action', success, fail })
    },
    deletestaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deletestaff(payload), { type: 'action', success, fail })
    },
    getorgportalmenutree(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getorgportalmenutree(payload), { type: 'list', success, fail })
    },
    getinspectionneeds(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getinspectionneeds(payload), { type: 'list', success, fail })
    },
    getacceptablestaffs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getacceptablestaffs(payload), { type: 'list', success, fail })
    },
    acceptinspectionneed(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.acceptinspectionneed(payload), { type: 'action', success, fail })
    },
    notacceptinspectionneed(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.notacceptinspectionneed(payload), { type: 'action', success, fail })
    },
    assigninspectionneed(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.assigninspectionneed(payload), { type: 'action', success, fail })
    },
    confirmnamecard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.confirmnamecard(payload), { type: 'action', success, fail })
    },
    // ----------------------------------------------------------------------
    getworkorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getworkorders(payload), { type: 'list', success, fail })
    },
    deleteworkorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deleteworkorder(payload), { type: 'action', success, fail })
    },
    completionworkorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.completionworkorder(payload), { type: 'action', success, fail })
    },
    addworkorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addworkorder(payload), { type: 'action', success, fail })
    },
    updateworkorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updateworkorder(payload), { type: 'action', success, fail })
    },
    // -----------------------------------------------------------------------
    setvendorsupervisor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setvendorsupervisor(payload), { type: 'action', success, fail })
    },
    // 机构
    getseaports(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getseaports(payload), { type: 'list', success, fail })
    },
    deleteseaport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deleteseaport(payload), { type: 'action', success, fail })
    },
    getseaport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getseaport(payload), { type: 'info', success, fail })
    },
    addseaport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addseaport(payload), { type: 'action', success, fail })
    },
    updateseaport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updateseaport(payload), { type: 'action', success, fail })
    },
    // 企业
    getvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendors(payload), { type: 'list', success, fail })
    },
    getvendornames(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendornames(payload), { type: 'list', success, fail })
    },
    deletevendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deletevendor(payload), { type: 'action', success, fail })
    },
    getvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendor(payload), { type: 'info', success, fail })
    },
    addvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addvendor(payload), { type: 'action', success, fail })
    },
    updatevendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updatevendor(payload), { type: 'action', success, fail })
    },
    // 企业审核
    applyvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.applyvendor(payload), { type: 'action', success, fail })
    },
    getapplyvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getapplyvendors(payload), { type: 'list', success, fail })
    },
    auditvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.auditvendor(payload), { type: 'action', success, fail })
    },
    // 套餐
    getallpackages(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getallpackages(payload), { type: 'list', success, fail })
    },
    // 商品
    getproducts(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getproducts(payload), { type: 'list', success, fail })
    },
    deleteproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deleteproduct(payload), { type: 'action', success, fail })
    },
    addproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addproduct(payload), { type: 'action', success, fail })
    },
    addproducts(context, { payload }) {
      const list = []
      payload.forEach(i => {
        list.push(Common.addproduct(i))
      })
      return Promise.all(list)
    },
    updateproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updateproduct(payload), { type: 'action', success, fail })
    },
    modifypassword(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.modifypassword(payload), { type: 'action', success, fail })
    },
    resetpassword(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.resetpassword(payload), { type: 'action', success, fail })
    },
    getzsvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getzsvendors(payload), { type: 'list', success, fail })
    },
    getallexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getallexpresses(payload), { type: 'list', success, fail })
    },
    getexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getexpresses(payload), { type: 'list', success, fail })
    },
    setvendorexpress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setvendorexpress(payload), { type: 'action', success, fail })
    },
    setvendoradminuser(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setvendoradminuser(payload), { type: 'action', success, fail })
    }
  }
}
